import { Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CompanyDocumentsService } from '../../service/company-documents.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { DocumentTypeDTO, RegisterCompanyDocumentRequestDTO, RegisterCompanyDocumentResponseDTO } from '../../interface/company-document.interface';
import Swal from 'sweetalert2';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';
import { DocumentTemplateApiCallerService, UsedTemplateDocuments } from 'src/app/pages/document-templates/services/document-template-api-caller.service';

@Component({
  selector: 'app-upload-company-docs-modal',
  templateUrl: './upload-company-docs-modal.component.html',
  styleUrls: ['./upload-company-docs-modal.component.scss'],
})
export class UploadCompanyDocsModalComponent implements OnInit{
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  public uploadForm: FormGroup;
  public docTypes$: Observable<DocumentTypeDTO[]>;

  constructor(private companyDocumentsService: CompanyDocumentsService,
    private dialogRef: MatDialogRef<UploadCompanyDocsModalComponent>,
    @Inject(MAT_DIALOG_DATA)public companyId: number,
    private _fb: FormBuilder
  ){
    this.docTypes$ = new Observable;
  }

  ngOnInit(): void {
    this.uploadForm = this._fb.group({
      file: [undefined, [Validators.required]],
      documentType: [null, [Validators.required]],
      description: [null]
    });
    this.getDocumentTypes();
  }

  public closeDialog() {
    this.dialogRef.close(false);
  }

  public getDocumentTypes() {
    this.docTypes$ = this.companyDocumentsService.getDocumentTypes();
  }

  droppedFile(files: NgxFileDropEntry[]) {
    const fileToUpload = files[0].fileEntry;
    if(fileToUpload.isFile) {
      const fileEntry = (fileToUpload as FileSystemFileEntry);
      fileEntry.file((file: File) => {
        this.uploadForm.patchValue({file: file});
      });
    }
  }

  handleRemoveFile() {
    if(this.file) {
      this.uploadForm.patchValue({file: undefined});
    }
  }

  get file() {
    return this.uploadForm.controls['file'].value;
  }

  private showSuccessMessage(response: ActionResponseDTO<RegisterCompanyDocumentResponseDTO> ){
    Swal.fire({
      icon: 'success',
      title: response.resultMessage,
      allowEnterKey: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'OK',
    }).then((r) => {
      if(r.isConfirmed) {
        this.dialogRef.close(true);
      }
    });
  }

  public submitUploadCompanyDocument(ovewrite: boolean = false) {
    const {file, documentType, description} = this.uploadForm.value;
    const request: RegisterCompanyDocumentRequestDTO = {
      documentTypeId: documentType,
      description: description,
      uploadFile: file
    };

    Swal.fire({
      title: 'Subiendo documento',
      didOpen:() => {
        Swal.showLoading();
        this.companyDocumentsService.uploadCompanyDocument(this.companyId, request, ovewrite)
        .subscribe({
          next:(res) => {
            this.showSuccessMessage(res);
          }, 
          error: (err) => {
            if(err.status === 409) {
              Swal.fire({
                icon: 'error',
                title: err.error.resultMessage,
                text: '¿Desea sobrescribir el documento?',
                confirmButtonText: 'Sí',
                denyButtonText: 'No',
                showDenyButton: true,
              }).then((r) => {
                if(r.isConfirmed) {
                  this.submitUploadCompanyDocument(true);
                }
              })
            } else {
              Swal.fire({
                icon: 'error',
                title: err.error.resultMessage
              });
            }
         
          }
        });
      }
    })
  }

}
